import styled from 'styled-components';

export const ImagesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  position: relative;
  width: 90%;
  max-width: 1440px;
`;

export const ImagesPack = styled.img`
  width: 90%;
  height: auto;
  margin: 0 auto;

  @media(min-width: 100px) and (max-width: 767px){
    display: none;
  }

  @media (min-width: 768px) and (max-width: 4000px) {
    display: block; 
  }
`

export const Image1 = styled.img`
  width: 234.11px;
  height: 291.13px;
  margin: 80px 10px 0 20px;
  border-radius: 12px;
  object-fit: cover;

  @media(min-width: 300px) and (max-width: 349px){
    width: 154.11px;
    height: 211.13px;
    margin: 80px 10px 0 0px;
  }

  @media(min-width: 350px) and (max-width: 399px){
    width: 164.11px;
    height: 221.13px;
    margin: 0px 10px 0 0px;
  }

  @media(min-width: 400px) and (max-width: 419px){
    width: 194.11px;
    height: 251.13px;
    margin: 0px 10px 0 0px;
  }

  @media(min-width: 420px) and (max-width: 499px){
    width: 204.11px;
    height: 261.13px;
    margin: 0px 10px 0 0px;
  }

  @media(min-width: 500px) and (max-width: 599px){
    width: 204.11px;
    height: 261.13px;
    margin: 80px 10px 0 0px;
  }

  @media(min-width: 600px) and (max-width: 767px){
    width: 244.11px;
    height: 301.13px;
    margin: 80px 10px 0 0px;
  }

  @media(min-width: 768px) and (max-width: 10000px){
    display: none !important;
  }
`;

export const Image2 = styled.img`
  width: 234.11px;
  height: 291.13px;
  margin: 20px 20px 0 20px;
  border-radius: 12px;
  object-fit: cover;

  @media(min-width: 300px) and (max-width: 349px){
    width: 154.11px;
    height: 211.13px;
    margin: 20px 0px 0 0px;
  }

  @media(min-width: 350px) and (max-width: 399px){
    width: 164.11px;
    height: 221.13px;
    margin: -20px 0px 0 0px;
  }

  @media(min-width: 400px) and (max-width: 419px){
    width: 194.11px;
    height: 251.13px;
    margin: -30px 0px 0 0px;
  }

  @media(min-width: 420px) and (max-width: 499px){
    width: 204.11px;
    height: 261.13px;
    margin: -30px 0px 0 0px;
  }

  @media(min-width: 500px) and (max-width: 599px){
    width: 204.11px;
    height: 261.13px;
    margin: 20px 10px 0 0px;
  }

  @media(min-width: 600px) and (max-width: 767px){
    width: 244.11px;
    height: 301.13px;
    margin: 20px 10px 0 0px;
  }

  @media(min-width: 768px) and (max-width: 10000px){
    display: none !important;
  }
`;
